import { ReactElement, useState, useMemo } from 'react';
import { CircularProgress } from '@mui/material';
import { compact } from 'lodash';

import { useRequest } from '~hooks/index';
import {
  getSkillsTypesCompany,
  getServiceTypesCompany,
} from '~services/enumerations';
import { getLogistiscZonesInfo } from '~services/logisticsZones';
import { LogisticZoneBase } from '~services/logisticsZones/types';
import { sortAlphabeticZoneByCode } from '~utils/logisiticsZones';

import { DialogOrdersMultipeEditionProps } from './types';
import DialogOrdersMultipeEditionContent from './Content';
import {
  DialogOrdersMultipeEditionContainer,
  DialogOrdersMultipeEditionLoadingContainer,
} from './styles';

const DialogOrdersMultipeEdition = ({
  open,
  onClose,
  selectedIds,
  onSuccessSubmit,
}: DialogOrdersMultipeEditionProps): ReactElement => {
  const [skillsTypes, setSkillsTypes] = useState<string[]>([]);
  const [, loadingSkillsTypes] = useRequest({
    request: getSkillsTypesCompany,
    payload: null,
    withPostSuccess: (response) => {
      const skillsListResponse = compact(
        response.data?.data.results as string[],
      );

      setSkillsTypes(skillsListResponse);
    },
  });

  const [serviceTypes, setServicesTypes] = useState<string[]>([]);
  const [, loadingServiceTypes] = useRequest({
    request: getServiceTypesCompany,
    payload: null,
    withPostSuccess: (response) => {
      const servicesListResponse = compact(
        response.data?.data.results as string[],
      );

      setServicesTypes(servicesListResponse);
    },
  });

  const [logisticsZones, setLogisticsZone] = useState<LogisticZoneBase[]>([]);
  const [, loadingLogisticsZone] = useRequest({
    request: getLogistiscZonesInfo,
    payload: null,
    withPostSuccess: (response) => {
      const logisitcisZoneResponse = response.data?.data
        .results as LogisticZoneBase[];

      const sortedLogisitcisZoneResponse = sortAlphabeticZoneByCode(
        logisitcisZoneResponse,
      );

      setLogisticsZone(sortedLogisitcisZoneResponse);
    },
  });

  const loading = useMemo(
    () => loadingSkillsTypes || loadingServiceTypes || loadingLogisticsZone,
    [loadingSkillsTypes, loadingServiceTypes, loadingLogisticsZone],
  );

  return (
    <DialogOrdersMultipeEditionContainer open={open}>
      {loading && (
        <DialogOrdersMultipeEditionLoadingContainer>
          <CircularProgress color="primary" disableShrink size={80} />
        </DialogOrdersMultipeEditionLoadingContainer>
      )}

      {!loading && (
        <DialogOrdersMultipeEditionContent
          onClose={onClose}
          selectedIds={selectedIds}
          skillsNeededOptions={skillsTypes}
          serviceTypesOptions={serviceTypes}
          zoneOptions={logisticsZones}
          onSuccessSubmit={onSuccessSubmit}
        />
      )}
    </DialogOrdersMultipeEditionContainer>
  );
};

export default DialogOrdersMultipeEdition;
